import { Divider, Flex } from '@chakra-ui/react'
import { useState } from 'react'
import { BsClipboardData } from 'react-icons/bs'
import TableWaitingApproveList from '../components/admindashboard/TableWaitingApproveList'
import { BlockContainer, BlockHeader } from '../components/shared/Block'
import SelectedItemAlertContext, { defaultSelectData } from '../context/selectedItemAlertContext'


const AdminNewForms = () => {
    const [itemData, setItemData] = useState(defaultSelectData)

    return (
        <Flex p="40px"  direction="column" w="full">
            <BlockContainer>
                <BlockHeader title="รายการแบบคำร้องที่รอการตรวจสอบ" icon={BsClipboardData} >
                </BlockHeader>
                <Divider />
                <Flex w="full" pt={5}>
                    <SelectedItemAlertContext.Provider value={[itemData, setItemData]}>
                        <TableWaitingApproveList />
                    </SelectedItemAlertContext.Provider>
                </Flex>
            </BlockContainer>
        </Flex>
    )
}

export default AdminNewForms
